import { type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { notEmpty } from "shared/lib/utils";

import type { articleSearchResultListArticleSearchEdge$key } from "scmp-app/queries/__generated__/articleSearchResultListArticleSearchEdge.graphql";

import { Item, List } from "./styles";

export type Props = {
  reference: articleSearchResultListArticleSearchEdge$key;
};

export const ArticleSearchResultList: FunctionComponent<Props> = ({ reference }) => {
  const results = useFragment(
    graphql`
      fragment articleSearchResultListArticleSearchEdge on ArticleSearchEdge @relay(plural: true) {
        node {
          id
          content {
            ...searchContentItemContent
          }
        }
      }
    `,
    reference,
  );

  return (
    notEmpty(results) && (
      <List>
        {results?.map(
          ({ node }) => node.content && <Item key={node.id} reference={node.content} />,
        )}
      </List>
    )
  );
};

ArticleSearchResultList.displayName = "ArticleSearchResultList";
